import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

type EntityType = 'customer' | 'interaction';

export async function customerAttribute(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  return attribute('customer', condition, context);
}

export async function interactionAttribute(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  return attribute('interaction', condition, context);
}

async function attribute(
  entityType: EntityType,
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { operator, attribute: attributeNo, value } = condition[1] ?? {};

  const entityId: string =
    entityType === 'customer'
      ? context.bridge.customerId
      : context.bridge.interactionId;
  const objects =
    entityId &&
    (await context.bridge.load({ objectType: entityType, id: entityId }));
  const entity = objects?.[0];

  if (operator === 'contains') {
    return value.includes(entity?.[attributeNo]);
  }
  if (operator === '!contains') {
    return !value.includes(entity?.[attributeNo]);
  }
}
